import drawnBulletsPagination from "../helpers/drawnBulletsPagination";

class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper, Pagination, Navigation }) => {
      const swiperParams = {
        modules: [Pagination, Navigation],
        slidesPerView: "auto",
        speed: 400,
        loop: true,
        spaceBetween: 50,
        pagination: drawnBulletsPagination,
        navigation: {
          nextEl: "[data-next]",
          prevEl: "[data-previous]",
        },
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy();
  }
}

if (!customElements.get("complementary-products")) {
  customElements.define("complementary-products", ComplementaryProducts);
}
